import { Class, Options, Events } from "@webhare-system/frameworks/mootools/core";

require('@webhare-system/frameworks/mootools/core');
var WHBase = require('@webhare-system/compat/base');
var $todd = require("./support");
var JSONRPC = require('@webhare-system/net/jsonrpc');
var utilerror = require('@webhare-system/wh/errorreporting');
var urlapi = require('@webhare-system/internal/url');
var Promise = require('@webhare-system/compat/promise');

/****************************************************************************************************************************
 * NG communication code
 */

/** Implements the todd end of a reliable communication link
*/
$todd.LinkEndPoint = new Class(
{ Implements: Options

, options:
    { linkid:  ''
    , commhost: ''
    , frontendid: ''
//    , onmessage: function() {}
//    , onclosed: function() {}
    }

  // Current sequence nr for messages
, msgcounter: 0

  // List of meessages (unacked & unsent)
, queuedmessages: []

  // Don't transmit immediately
, stoptransmit: false

  // Seqnr of last message sent over the wire
, lastsentseqnr: 0

  // Seqnr of last (correctly) received message
, lastreceivedseqnr: 0

  // Linked TransportManager
, transmgr: null

  // Transport (used by TransportManager)
, transport: null

  // Set to true when a new message was seen since the last constructed wire message
, seennewmessage: false

  // ---------------------------------------------------------------------------
  //
  // Constructor
  //

, initialize: function(options)
  {
    this.setOptions(options);
    //console.log('** new endpoint', this.options.linkid, this.options.frontendid, this.options.commhost);
  }

  // ---------------------------------------------------------------------------
  //
  // Helper stuff
  //

  /* Processes incoming wire message
     @return Whether all messages were sent
  */
, processWireMessage: function(wiremsg)
  {
    //console.log('** wire msg', wiremsg);

    if (wiremsg.status == "gone")
    {
//      console.log('** link closed - unregistering');
      if (this.onclosed)
        this.onclosed();
      this.unregister();
      return true;
    }

    // Remove ack'ed messages
    let i = 0;
    for (; i < this.queuedmessages.length; ++i)
      if (this.queuedmessages[i].seqnr > wiremsg.ack)
        break;

    // Dispatch all messages we haven't received yet
    this.queuedmessages.splice(0, i);

    for (i = 0; i < wiremsg.messages.length; ++i)
    {
      //console.log('dispatch message', this.options.linkid, wiremsg.messages[i].seqnr, this.lastreceivedseqnr + 1);
      if (wiremsg.messages[i].seqnr == this.lastreceivedseqnr + 1)
      {
        // Mark as received first, processing the message can throw...
        ++this.lastreceivedseqnr;
        this.seennewmessage = true;

        //console.log('onmessage');
        this.onmessage(wiremsg.messages[i].data);

      }
    }

    return this.queuedmessages.length == 0;
  }

, constructWireMessage: function(sendall)
  {
    var startmsgpos = 0;
    if (!sendall)
      for (; startmsgpos < this.queuedmessages.length; ++startmsgpos)
        if (this.queuedmessages[startmsgpos].seqnr > this.lastsentseqnr)
          break;

    this.lastsentseqnr = this.msgcounter;
    var wiremsg =
        { linkid: this.options.linkid
        , messages: this.queuedmessages.slice(startmsgpos)
        , ack: this.lastreceivedseqnr
        , frontendid: this.options.frontendid
        , needack: this.queuedmessages.length != 0
        };

    this.seennewmessage = false;
    return wiremsg;
  }

  // ---------------------------------------------------------------------------
  //
  // Public API
  //

  /// Register this endpoint with a communicationManager
, register: function(transmgr)
  {
    this.transmgr = transmgr;
    this.transmgr.register(this);
    // Automatically signalled
  }

  /// Unregister the endpoint
, unregister: function()
  {
    if (this.transmgr)
      this.transmgr.unregister(this);
    this.transmgr = null;
    this.queuedmessages=[];
  }

  /// Queue a new message. Returns the message nr (which is monotonically increasing in time)
, queueMessage: function(message)
  {
    $todd.DebugTypedLog("rpc", '** QUEUE MESSAGE',message);
    this.queuedmessages.push({ seqnr: ++this.msgcounter, data: message });

    if (!this.stoptransmit && this.transport)
      this.transport.setSignalled(this);

    return this.msgcounter;
  }

  /** Indicate that messages have been received through another channel. Pass the seqnr of the last message.
      Use this when initial messages are transferred by service call before setting up the comm channel.
  */
, registerManuallyReceivedMessage: function(seqnr)
  {
    //console.log('registerManuallyReceivedMessage', seqnr);
    this.lastreceivedseqnr = seqnr;
  }
});

/** The transportManager handles setting up transports for the endpoints
*/
$todd.TransportManager = new Class(
{ Implements: [ Options, Events ]

, options: {}

  /** List of registered endpoints
      @cell linkid
      @cell endpoint
      @cell transport
  */
, endpoints: []

  /** List of registered transports
      @cell endpoints Registered endpoints
      @cell commurl Communication url
      @cell trans Transport object
  */
, transports: []

  // ---------------------------------------------------------------------------
  //
  // Constructor
  //

, initialize: function(options)
  {
    this.setOptions(options);
  }

  // ---------------------------------------------------------------------------
  //
  // Endpoint internal API
  //

  /** Registers an endpoint
  */
, register: function(endpoint)
  {
    var commhost = endpoint.options.commhost;

    var transport = null;
    for (var i = 0; i < this.transports.length; ++i)
      if (this.transports[i].options.commhost == commhost)
        transport = this.transports[i];

    if (!transport)
    {
      if (!$todd.commfallback && window.SharedWorker && window.WebSocket)
      {
        console.log('Using WebSocket transport via sharedworker');
        transport = new $todd.SharedWebSocketTransport(
            { commhost: commhost
            });
      }
      /*else if (!$todd.commfallback && window.WebSocket)
      {
        // Doesn't seem to work on Firefox, some problems with cookies?
        console.warn('Using WebSocket transport'); // FIXME: websocket transport isn't nearly as error-resilient as shared worker transport
        transport = new $todd.WebSocketTransport(
            { commhost: commhost
            });
      }*/
      else
      {
        console.warn('Using fallback (JSONRPC) transport');
        transport = new $todd.JSONRPCTransport(
            { commhost: commhost
            });
      }

      transport.addEvent("online", this._gotOnline.bind(this));
      transport.addEvent("offline", this._gotOffline.bind(this));

      this.transports.push(transport);
    }

    this.endpoints.push(endpoint);

    //console.log('** register endpoint ', endpoint, 'set transport to', transport);
    transport.addEndPoint(endpoint);

    transport.setSignalled(endpoint);
  }

  /** Unregisters an endpoint
  */
, unregister: function(endpoint)
  {
    console.log('unregistering endpoint frontendid:', endpoint.options.frontendid || "-", "linkid:", endpoint.options.linkid || "-", this.endpoints.length, endpoint.transport.endpoints.length);
    this.endpoints.erase(endpoint);
    if (endpoint.transport)
    {
      var transport = endpoint.transport;
      if (!transport.removeEndPoint(endpoint))
      {
        transport.destroy();
        this.transports.erase(transport);
      }
      console.log('unregistered endpoint', this.endpoints.length, transport.endpoints.length);
    }
  }

  // ---------------------------------------------------------------------------
  //
  // Callbacks
  //

, _gotOnline: function(event)
  {
    this.fireEvent("online", { target: this });
  }

, _gotOffline: function(event)
  {
    this.fireEvent("offline", { target: this });
  }

  // ---------------------------------------------------------------------------
  //
  // Public API
  //

  /// Signal shutdown
, prepareForUnload: function()
  {
    this.transports.each(function(item){ item.unloading = true; });
  }

  /// Signal shutdown
, executeUnload: function()
  {
    // Send the dying message (cancel any pending requests). IE 11 doesn't cancel them within iframe
    // which the tests don't like
//    console.log('startRequest for transports ', this.transports.length);
    this.transports.each(function(item){ item.runUnloadHandler(); });
  }

  /// Release all resources
, destroy: function()
  {
    this.transports.each(function(item){item.destroy();});
    this.endpoints = [];
    this.transports = [];
  }
});

$todd.TransportBase = new Class(
{ Implements: [ Options, Events ]

, serializer: null

, options:
      { commurl:          ''
      , onrequestneeded:  null
      , onresponse:       null
      }

  /// List of endpoints
, endpoints: []

, initialize: function(options)
  {
    this.setOptions(options);
    this.serializer = Promise.resolve();
  }

, destroy: function()
  {
  }

, setSignalled: function(endpoint)
  {
  }

, addEndPoint: function(endpoint)
  {
    endpoint.transport = this;
    this.endpoints.push(endpoint);
  }

, removeEndPoint: function(endpoint)
  {
    endpoint.transport = null;
    this.endpoints.erase(endpoint);
    return this.endpoints.length != 0;
  }

  /// Called within onunload handler - to push out stuff as quick as possible
, runUnloadHandler: function()
  {
  }

, processGotMessageMessage:function(msg)
  {
    // Finally process the message _finally to absorb crashes.
    this.serializer = this.serializer.finally(this.processWireMessage.bind(this, msg)).catch(utilerror.reportException);
  }

, processWireMessage:function(msg)
  {
    for (var j = 0; j < this.endpoints.length; ++j)
      if (this.endpoints[j].options.linkid == msg.linkid)
      {
        var endpoint = this.endpoints[j];

        // FIXME trycatch!
        endpoint.processWireMessage(msg);

        if (endpoint.seennewmessage && this.endpoints.contains(endpoint))
          this.gotNewMessage(endpoint);
      }
  }

  // Called when a new message has arrived at an endpoint
, gotNewMessage:function(endpoint)
  {
  }
});


/// JSONRPC support
$todd.JSONRPCTransport = new Class(
{ Extends: $todd.TransportBase

, options:
    { commhost: ''
    }

, jsonrpc: null
, request: null
, scheduled: false
, unloading: false
//  , sendallmessages: true

, fails: 0
, online: false

, initialize: function(options)
  {
    this.parent(options);

    $todd.DebugTypedLog("rpc", '** create JSONRPC transport');

    this.jsonrpc = new JSONRPC(
      { url: WHBase.config.tollium.toddservice
      , appendfunctionname: true
      , log: $todd.IsDebugTypeEnabled('rpc')
      });

    this.startRequest.bind(this).delay(1);
    this.scheduled = true;
  }

, destroy: function()
  {
    if (this.jsonrpc)
      this.jsonrpc.destroy();
    this.jsonrpc = null;
  }

, setSignalled: function(endpoint)
  {
    if (!this.scheduled && !this.unloading)
    {
      $todd.DebugTypedLog("rpc", '** JSONRPC scheduling request');
      this.startRequest.bind(this).delay(1);
    }
    this.scheduled = true;
  }

, startRequest: function()
  {
    if (!this.jsonrpc)
      return;

    if (this.request)
    {
      $todd.DebugTypedLog("rpc", '** JSONRPC cancel current request');
      this.request.cancel();
      this.request = null;
    }

    $todd.DebugTypedLog("rpc", '** JSONRPC start new request');
    this.scheduled = false;
    this.running = true;

    var req = { links: [], frontendids: [], unloading: this.unloading };
    for (var i = 0; i < this.endpoints.length; ++i)
    {
      req.links.push(this.endpoints[i].constructWireMessage(true));
      req.frontendids.include(this.endpoints[i].options.frontendid);
    }

    // Synchronous request when we're unloading for our very last message. Lower the timeout somewhat then.
    this.request = this.jsonrpc.request('RunToddComm',
                                        [ req ],
                                        this.gotSuccess.bind(this),
                                        this.gotFailure.bind(this),
                                        { timeout: this.unloading ? 500 : 300000
                                        , synchronous: this.unloading && !$todd.fastunload
                                        });
  }

, gotSuccess: function(data)
  {
    $todd.DebugTypedLog("rpc", '** JSONRPC got response', data, this.endpoints);

    if (!this.online)
      this.fireEvent("online", { target: this });

    this.fails = 0;
    this.online = true;

    // Indicate we aren't processing, and schedule the next request before processing messages throws.
    this.request = null;
    this.setSignalled();

    for (var i = 0; i < data.links.length; ++i)
    {
      var msg = data.links[i];
      this.processWireMessage(msg);
    }
  }

, gotFailure: function(data)
  {
    $todd.DebugTypedLog("rpc", '** JSONRPC got FAILURE', data);

    // Two fails in a row: offline
    if (this.fails)
    {
      this.online = false;
      this.fireEvent("offline", { target: this });
    }

    if (++this.fails < 10)
      this.startRequest.bind(this).delay(300 * this.fails * this.fails); //exp backoff. first retry will be after 300msec, last attempt (#9) after 30 sec
  }

, runUnloadHandler: function()
  {
    // If scheduled start request immediately, don't want to wait for any delayed stuff
    if (this.scheduled)
      this.startRequest();
  }
});

// FIXME: websocket transport isn't nearly as error-resilient as shared worker transport
// Should share the reconnect code

/// WebSocket support
$todd.WebSocketTransport = new Class(
{ Extends: $todd.TransportBase

, options:
    { commhost: ''
    }

, socket: null
, signalled: []
, sentall: []

, jsonrpc: null

, initialize: function(options)
  {
    this.parent(options);

    $todd.DebugTypedLog("rpc", '** create WebSocket transport');

    var url = urlapi.resolveToAbsoluteURL(WHBase.config.tollium.toddservice, '/.tollium/ui/comm.whsock');
    var unpacked_url = urlapi.unpackURL(url);
    if (unpacked_url.scheme == "http")
      unpacked_url.scheme = "ws";
    else if (unpacked_url.scheme == "https")
      unpacked_url.scheme = "wss";
    url = urlapi.repackURL(unpacked_url);

//    console.log('open transport', this.options);
//    console.trace();
    this.socket = new WebSocket(url);
    this.socket.addEventListener('open', this.gotOpen.bind(this));
    this.socket.addEventListener('message', this.gotMessage.bind(this));

    this.jsonrpc = new JSONRPC(
      { url: WHBase.config.tollium.toddservice
      , appendfunctionname: true
      , log: $todd.IsDebugTypeEnabled('rpc')
      });

    //this.startRequest.delay(1);
    this.scheduled = true;
  }

, destroy: function()
  {
    if (this.jsonrpc)
      this.jsonrpc.destroy();
    this.jsonrpc = null;

    if (this.socket)
      this.socket.close();
    this.socket = null;
  }

, addEndPoint: function(endpoint)
  {
    this.parent(endpoint);
    this.updateListenLinks();
  }

, removeEndPoint: function(endpoint)
  {
    var res = this.parent(endpoint);
    this.updateListenLinks();

    this.signalled.erase(endpoint);
    this.sentall.erase(endpoint);

    return res;
  }

, gotOpen: function()
  {
//    console.log('gotopen');
    this.updateListenLinks();
  }

, gotMessage: function(message)
  {
    var rawmsg = JSON.parse(message.data);
    for (var i = 0; i < rawmsg.msg.data.length; ++i)
    {
      var msg = rawmsg.msg.data[i];
      this.processGotMessageMessage(msg);
    }
  }

, setSignalled: function(endpoint)
  {
//    console.log('endpoint signalled', endpoint.options.linkid, this.socket ? this.socket.readyState : 'n/a');
    this.signalled.include(endpoint);
    if (this.socket && this.socket.readyState == 1)
      this.handleSignalledEndpoints();
  }

, updateListenLinks: function()
  {
    if (!this.socket || this.socket.readyState != 1)
      return;

    var links = [];
    var frontendids = [];

    this.endpoints.each(function(endpoint)
      {
        links.include(endpoint.options.linkid);
        frontendids.include(endpoint.options.frontendid);
      });

    this.socket.send(JSON.stringify({ requests: [ { type: 'listen', links: links, frontendids: frontendids } ] }));
  }

, handleSignalledEndpoints: function()
  {
    //console.log('handleSignalledEndpoints');
    for (var i = 0; i < this.signalled.length; ++i)
    {
      var endpoint = this.signalled[i];
      //console.log(' handle signalled endpoint', endpoint.options.linkid);

      var sentall = this.sentall.contains(endpoint);
      var msg = endpoint.constructWireMessage(!sentall);
      this.socket.send(JSON.stringify({ requests: [ { type: 'msg', msg: msg } ] }));
      if (!sentall)
        this.sentall.include(endpoint);
    }

    this.signalled.empty();
  }

});

/// WebSocket via sharedworker support
$todd.SharedWebSocketTransport = new Class(
{ Extends: $todd.TransportBase

, options:
    { commhost: ''
    }

, worker: null
, signalled: []
, sentall: []
, toack: []
, online: false

, timeoutctr: 0
, timeout: null

, jsonrpc: null

, initialize: function(options)
  {
    this.parent(options);

    // Init JSON RPC for cookies FIXME still needed?
    this.jsonrpc = new JSONRPC(
      { url: WHBase.config.tollium.toddservice
      , appendfunctionname: true
      , log: $todd.IsDebugTypeEnabled('rpc')
      });

    this._initWorker(true);
  }

, destroy: function()
  {
    this.signalled.empty();
    this.sentall.empty();
    this.toack.empty();
    this._updateAckTimeout();
    if (this.timeout)
      clearTimeout(this.timeout);

    this._closeWorker();
  }


, _initWorker: function(firststart)
  {
    $todd.DebugTypedLog("rpc", '** create WebSocket transport');

    if (this.worker)
      this._closeWorker();

    this.worker = new SharedWorker(WHBase.config.tollium.sharedworker);
    this.worker.onerror = this._gotWorkerError.bind(this);
    this.worker.port.onmessage = this._gotMessage.bind(this);
    this.worker.port.postMessage({ type: 'tollium-ws-openconnection', firststart: firststart });

    if (!this.timeout)
      this.timeout = this._gotTimeout.bind(this).delay(7000);
  }

, _closeWorker: function()
  {
    if (this.worker)
    {
      this.worker.port.postMessage({ type: 'close' });
      this.worker.port.close();
    }
    this.worker = null;
  }

, _gotMessage: function(event)
  {
    this.timeoutctr = 0;

    $todd.DebugTypedLog("rpc", 'shared worker message:', event.data);

    switch (event.data.type)
    {
      case 'online':
      {
        this.online = true;
        this._handleReconnect();
        this.fireEvent("online", { target: this });
      } break;
      case 'offline':
      {
        // We're disconnected for now. FIXME: what to do?
        let wasonline = this.online;
        this.online = false;
        this.sentall.empty();

        if (wasonline)
          this.fireEvent("offline", { target: this });
      } break;
      case 'message':
      {
        var msg = event.data.data;
        this.processGotMessageMessage(msg);
      } break;
      case 'ping':
      {
        if (this.worker)
          this.worker.port.postMessage({ type: 'pong', msg: "responding at " + new Date().getTime() });

        if (this.timeout)
        {
          clearTimeout(this.timeout);
          this.timeout = this._gotTimeout.bind(this).delay(7000);
        }
      } break;
      case "close":
      {
        console.log("Got close message, shared worker has terminated the connection");

        // We're disconnected for now.
        let wasonline = this.online;
        this.online = false;
        this.sentall.empty();

        if (wasonline)
          this.fireEvent("offline", { target: this });

        // Reinit the worker
        this._initWorker(false);
      }
    }
  }

, _gotWorkerError: function(error)
  {
    console.warn('shared worker error:', error);
    $todd.DebugTypedLog("rpc", 'shared worker error:',error);
  }

, _gotTimeout: function()
  {
    this.timeout = null;
    if (++this.timeoutctr >= 2)
    {
      console.warn("Too many timeouts, assuming worker is has terminated");

      var wasonline = this.online;
      this.online = false;
      this.sentall.empty();

      this._initWorker.bind(this, false).delay(1000);

      if (wasonline)
        this.fireEvent("offline", { target: this });
    }
    else
      this.timeout = this._gotTimeout.bind(this).delay(6000);
  }

, _updateListenLinks: function()
  {
    if (!this.worker || !this.online)
      return;

    var links = [];
    var frontendids = [];

    this.endpoints.each(function(endpoint)
      {
        links.include(endpoint.options.linkid);
        frontendids.include(endpoint.options.frontendid);
      });

    this.worker.port.postMessage({ type: 'tollium-ws-setlistenlinks', links: links, frontendids: frontendids });
  }

, _handleSignalledEndpoints: function()
  {
    //console.log('handleSignalledEndpoints');
    for (var i = 0; i < this.signalled.length; ++i)
    {
      var endpoint = this.signalled[i];
      $todd.DebugTypedLog("rpc", ' handle signalled endpoint', endpoint.options.linkid);

      var sentall = this.sentall.contains(endpoint);
      var msg = endpoint.constructWireMessage(!sentall);

      this.worker.port.postMessage({ type: 'tollium-ws-sendrequests', requests: [ { type: 'msg', msg: msg } ] });
      if (!sentall)
        this.sentall.include(endpoint);
    }

    this.signalled.empty();
    this.toack.empty();
    this._updateAckTimeout();
  }

, _handleReconnect: function()
  {
    // Update listen links
    this._updateListenLinks();

    // Resend for all endpoints
    this.endpoints.each(function(endpoint)
    {
      var msg = endpoint.constructWireMessage(true);

      this.worker.port.postMessage({ type: 'tollium-ws-sendrequests', requests: [ { type: 'msg', msg: msg } ] });
      this.sentall.include(endpoint);
    }.bind(this));

    this.signalled.empty();
    this.toack.empty();
    this._updateAckTimeout();
  }

, _updateAckTimeout: function()
  {
    if (!this.toack.length != !this.toack_cb)
    {
      if (this.toack.length)
        this.toack_cb = this._sendAcks.bind(this).delay(10000);
      else
      {
        clearTimeout(this.toack_cb);
        this.toack_cb = null;
      }
    }
  }

, _sendAcks: function()
  {
    this.signalled.combine(this.toack);
    if (this.online)
      this._handleSignalledEndpoints();
  }

, addEndPoint: function(endpoint)
  {
    this.parent(endpoint);
    this._updateListenLinks();

    if (!this.timeout)
      this.timeout = this._gotTimeout.bind(this).delay(6000);
  }

, removeEndPoint: function(endpoint)
  {
    var res = this.parent(endpoint);
    this._updateListenLinks();

    this.signalled.erase(endpoint);
    this.sentall.erase(endpoint);
    this.toack.erase(endpoint);

    if (!res)
    {
      if (this.timeout)
        clearTimeout(this.timeout);
      this.timeout = null;
    }
    return res;
  }

, setSignalled: function(endpoint)
  {
    //console.log('endpoint signalled', endpoint.options.linkid, this.online ? 'online' : 'offline');
    this.signalled.include(endpoint);
    if (this.online)
      this._handleSignalledEndpoints();
  }

, gotNewMessage:function(endpoint)
  {
    this.toack.include(endpoint);
    this._updateAckTimeout();
  }

});



// WEBPACK FOOTER //
// /opt/wh/whtree/modules/tollium/web/ui/js/commhandler.es